import React, {useEffect, useRef, useState} from "react";
import {useSelector, useDispatch, shallowEqual} from "react-redux";
import {TicketPrint} from "./TicketPrint";
import {Button} from "react-bootstrap";
import {useReactToPrint} from "react-to-print";
import {CircularProgress, TextField} from "@material-ui/core";
// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";
import AlertComponent from "_metronic/_helpers/AlertComponent";
import {onPrint} from "../requests";
import {actions} from "../_redux/ticketRedux";
import {isTicketCancellable} from "../../../../helpers";

const useStyles = makeStyles({
    progressRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
});

const Ticket = (props) => {
    const {
        onTicket,
        barcode,
        onBarcode,
        isLoading,
        errMsg,
        isError,
        setShowPaidWinning,
        ticket,
        setShowCancelTicket,
        setChooseGroupId,
        isScanner,
        setBarcode,
    } = props;
    const [isFocused, setIsFocused] = useState(false);

    const classes = useStyles();
    const {printData, printType} = useSelector(
        (state) => state.ticket,
        shallowEqual
    );
    const agentNumber = useSelector(
        (state) => state.auth?.user?.number,
        shallowEqual
    );
    const dispatch = useDispatch();
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const printTypes = {
        0: "isSalePrintable",
        1: "isWinPrintable",
        2: "isCancelPrintable",
        3: "isLostPrintable"
    };

    const canPrint = () => {
        if (printType === 0 && printData && +printData.agentNumber === agentNumber) {
            return printData[printTypes[0]];
        } else if (printType === 1 && printData.winningPaidStatus && printData) {
            return printData[printTypes[1]];
        } else if (
            printType === 2 &&
            printData &&
            +printData.agentNumber === agentNumber
        ) {
            return printData[printTypes[2]];
        }
        return false;
    };

    const onClickPrint = () => {
        onPrint(printType, printData.id)
            .then((res) => {
                handlePrint();
                res.data[printTypes[printType]] = false;
                dispatch(actions.setPrintData(res.data));
            })
            .catch(() => null);
    };

    const inputRef = useRef(null);

    useEffect(() => {
        const handleKeyPress = (event) => {
            inputRef.current.focus();
            !isFocused && setBarcode(event.key);
        };

        document.addEventListener("keypress", handleKeyPress);

        return () => {
            document.removeEventListener("keypress", handleKeyPress);
        };
    }, [isFocused]);

    return (
        <div className="d-flex flex-column align-items-center w-100 p-4">
            <div className="pr-4 w-50">
                <form
                    className="pb-4 d-flex"
                    onSubmit={(e) => {
                        e.preventDefault();
                        onTicket(barcode);
                    }}
                >
                    <TextField
                        fullWidth
                        id="barcode"
                        name="barcode"
                        label="Barkodu daxil et"
                        placeholder="Barkodu daxil et"
                        value={barcode}
                        onChange={(e) => onBarcode(e)}
                        inputRef={inputRef}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                    />
                    <Button type="submit">Axtar</Button>
                </form>
                {isError && (
                    <div>
                        <AlertComponent variant="info" message={errMsg}/>
                    </div>
                )}
                {Object.keys(printData).length && Object.keys(ticket).length ? (
                    <div className="d-flex justify-content-center">
                        {printData.statusId === 1 && (
                            <AlertComponent variant="info" message="Bilet uduşsuzdur."/>
                        )}
                        {printData.winningPaidStatus === false &&
                        printData.statusId === 2 &&
                        isScanner ? (
                            <Button
                                onClick={() => {
                                    setShowPaidWinning(true);
                                }}
                                variant="outline-info"
                                className="m-2"
                            >
                                Uduşlu bileti ödə ({printData.winningAmount}AZN)
                            </Button>
                        ) : (
                            ""
                        )}
                        {printData.statusId === 0 &&
                            isScanner &&
                            +printData.agentNumber === agentNumber && isTicketCancellable(printData.createdDate) && (
                                <Button
                                    onClick={() => {
                                        setShowCancelTicket(true);
                                        setChooseGroupId(printData.id);
                                    }}
                                    variant="warning"
                                    className="m-2"
                                >
                                    Bileti ləğv et
                                </Button>
                            )}
                        {((isScanner && canPrint()) ||
                            (printData.isSalePrintAllowed && printData.isSalePrintable) ||
                            (printData.isWinPrintAllowed && printData.isWinPrintable) ||
                            (printData.isCancelPrintAllowed && printData.isCancelPrintable) ||
                            (printData.isLostPrintAllowed && printData.isLostPrintable)) && (
                            <Button onClick={onClickPrint} variant="info" className="m-2">
                                Bileti çap et
                            </Button>
                        )}
                    </div>
                ) : (
                    ""
                )}
            </div>
            {isLoading ? (
                <div className={classes.progressRoot}>
                    <CircularProgress className={classes.progress}/>
                </div>
            ) : (
                Object.keys(ticket).length > 0 &&
                (printData.isSalePrintable ||
                    printData.isCancelPrintable ||
                    printData.isWinPrintable ||
                    printData.isLostPrintable) && (
                    <TicketPrint ref={componentRef} isScanner={isScanner}/>
                )
            )}
        </div>
    );
};

export default Ticket;
